import { createAction } from "redux-actions";
import { GET_USER_PERMISSIONS } from "../constants";
import { feathersFindDataAll } from "../services";

export const getUserPermissions = createAction(GET_USER_PERMISSIONS, (data) =>  feathersFindDataAll('users-permissions', data)())